import SVG from "../Assests/SVG";
import { Info } from "@mui/icons-material";
import { RouteType } from "./Routesconfig";
import WasteManagementDashboardLayout from "../Controller/LayoutController/WasteManagementDashboardLayout";
import GoogleMaps from "../Screens/WasteManagement/GoogleMaps";
import BinOverview from "../Screens/WaasteManagement/BinOverView/BinOverView";
import WasteCollectionType from "../Screens/WaasteManagement/WasteCollectionType/WasteCollectionType";
import BinOverviewReport from "../Screens/ReportSummary/BinOverviewReport";
import WasteOverviewReport from "../Screens/ReportSummary/WasteOverviewReport";
import WasteReport from "../Screens/ReportSummary/WasteOverviewReport";
import WasteManagementReportLayout from "../Controller/LayoutController/WasteManagementReportLayout";
import { t } from "i18next";
import DLCDashboard from "../Screens/WaasteManagement/DLC/DLC";
import DLCReport from "../Screens/ReportSummary/DLCReport";
import CtMHomeComponent from "../Screens/CTM/Maps/MapView";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import Screen from "./Layout/Screen";
import { AppRoutes } from "./Layout/Routes";

const WasteManagementAppRoutes: RouteType[] = [
  {
    path: AppRoutes.WASTEDASHBOARD,
    state: "WasteDashboard",
    element: <Screen.WasteManagementDashboardLayout />,
    sidebarProps: {
      displayText: "global.DashBoard",
      icon: <SVG.Dashboard />,
    },
    role: "SUPER_ADMIN",
    routeName: "WASTE_MANAGEMENT",
    child: [
      {
        path: AppRoutes.WASTEDASHBOARDCTMLIVEOVERVIEW,
        element: <CtMHomeComponent />,
        state: "WasteDashboardLiveOverView",
        sidebarProps: {
          displayText: "global.LiveOverView",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "WASTE_MANAGEMENT",
      },
      {
        path: AppRoutes.WASTEDASHBOARRDDIC,
        element: <Screen.DLCDashboard />,
        state: "WasteDashboardDIC",
        sidebarProps: {
          displayText: "global.DIC",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "WASTE_MANAGEMENT",
      },
      {
        path: AppRoutes.WASTEDASHBOARDLITTERBIN,
        element: <Screen.BinComponent />,
        state: "LitterBin",
        sidebarProps: {
          displayText: "global.litterBin",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "WASTE_MANAGEMENT",
      },
    ],
  },
  {
    path: AppRoutes.WASTEREPORT,
    state: "WasteReportSummary",
    element: <Screen.WasteManagementReportLayout />,
    sidebarProps: {
      displayText: "global.ReportSummary",
      icon: <SVG.ReportSummary />,
    },
    role: "SUPER_ADMIN",
    routeName: "WASTE_MANAGEMENT",
    child: [
      {
        path: AppRoutes.WASTEREPORTDICREPORT,
        element: <Screen.DLCReport />,
        state: "DICReport",
        sidebarProps: {
          displayText: "global.DICReport",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "WASTE_MANAGEMENT",
      },
    ],
  },

  {
    path: AppRoutes.CHATDASHBOARDLAYOUT,
    state: "ChatDashboardLayout",
    element: <Screen.ChatLayout />,
    sidebarProps: {
      displayText: "global.SensZAssistant",
      icon: <ChatBubbleOutlineOutlinedIcon />,
    },
    role: "SUPER_ADMIN",
    routeName: "WASTE_MANAGEMENT",
    child: [
      {
        path: AppRoutes.CHATDASHBOARD,
        state: "ChatDashboard",
        element: <Screen.ChatUIDashboard />,
        sidebarProps: {
          displayText: "global.ODC",
          icon: <ChatBubbleOutlineOutlinedIcon />,
        },
        role: "SUPER_ADMIN",
        routeName: "WASTE_MANAGEMENT",
      },
      {
        path: AppRoutes.FEEDBACKCHAT,
        state: "ChatDashboard",
        element: <Screen.FeedBackScreen />,
        sidebarProps: {
          displayText: "global.FeedBack",
          icon: <ChatBubbleOutlineOutlinedIcon />,
        },
        role: "SUPER_ADMIN",
        routeName: "WASTE_MANAGEMENT",
      },
      // {
      //   path: AppRoutes.SENSORCHAT,
      //   state: "ChatDashboard",
      //   element: <Screen.SensorScreen />,
      //   sidebarProps: {
      //     displayText: "global.sensor",
      //     icon: <ChatBubbleOutlineOutlinedIcon />,
      //   },
      //   role: "SUPER_ADMIN",
      //   routeName: "WASTE_MANAGEMENT",
      // },
    ],
  },
];

export default WasteManagementAppRoutes;
